"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.READY_STATE = exports.ALLOW_VIDEOS = exports.ALLOWED_FILE_TYPES = void 0;
var _keyBy = _interopRequireDefault(require("lodash/keyBy"));
var _mediaUtils = require("../../utils/media-utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ALLOW_VIDEOS = exports.ALLOW_VIDEOS = true;
var ALLOWED_FILE_TYPES = exports.ALLOWED_FILE_TYPES = _mediaUtils.acceptedFileTypes;
var READY_STATE = exports.READY_STATE = (0, _keyBy["default"])(['EMPTY', 'LOADING', 'DONE']);
//# sourceMappingURL=constants.js.map